export const formatDateToCustomString = (dateString: string, includeTime?: boolean): string => {
    const date = new Date(dateString);

    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();

    let formattedDate = `${day}/${month}/${year}`;

    if (includeTime) {
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');

        formattedDate += ` ${hours}:${minutes}`;
    }

    return formattedDate;
}

export const formatTimeSpanToCustomString = (timeSpanString: string, includeSeconds?: boolean): string => {
    const parts = timeSpanString.split(':');

    if (parts.length < 2 || parts.length > 3) {
        throw new Error('Invalid TimeSpan format');
    }

    const hours = parts[0].padStart(2, '0');
    const minutes = parts[1].padStart(2, '0');

    if (includeSeconds && parts.length === 3) {
        const seconds = parts[2].split('.')[0].padStart(2, '0');
        return `${hours}:${minutes}:${seconds}`;
    }

    return `${hours}:${minutes}`;
}

export const millisecondsToTimeSpan = (milliseconds: number): string => {
    const hours = Math.floor(milliseconds / 3600000);
    const minutes = Math.floor((milliseconds % 3600000) / 60000);
    const seconds = Math.floor(((milliseconds % 3600000) % 60000) / 1000);

    return `${hours}:${minutes}:${seconds}`;
}

export const secondsToTimeStr = (seconds: number) => {
    const h = Math.floor(seconds / 3600);
    const m = Math.floor((seconds % 3600) / 60);
    const s = Math.round(seconds % 60);
    return [
        h,
        m > 9 ? m : (h ? '0' + m : m || '0'),
        s > 9 ? s : '0' + s
    ].filter(Boolean).join(':');
}

